import { Component, OnInit } from '@angular/core';
import { MemberQuery, TransactionType } from '@fgb/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'fgb-activity-page',
  templateUrl: './activity-page.component.html',
  styleUrls: ['./activity-page.component.scss'],
})
export class ActivityPageComponent implements OnInit {
  name$: Observable<string>;

  constructor(private memberQuery: MemberQuery) {}
  transactionTypes = TransactionType;

  ngOnInit() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName} ${m.Surname}`;
        }
        return '';
      })
    );
  }
}
